import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/app/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/AppDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BiggestCatchDownloadSection"] */ "/app/src/components/BiggestCatchDownloadSection/BiggestCatchDownloadSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DepthInfoCard"] */ "/app/src/components/Cards/DepthInfoCard/DepthInfoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InfoCard"] */ "/app/src/components/Cards/InfoCard/InfoCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppStoreButtons"] */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalLink"] */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FishingReportsGrid"] */ "/app/src/components/FishingReportsGrid/FishingReportsGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationSafeDate"] */ "/app/src/components/HydrationSafeDate/HydrationSafeDate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageNavigation"] */ "/app/src/components/Navigation/PageNavigation/PageNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NextImageWrapper"] */ "/app/src/components/NextImage/NextImageWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QRCode"] */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/helpers/errorHandling/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NR_OF_RECENT_CATCHES_TO_SHOW","HeaderSection"] */ "/app/src/views/Species/components/HeaderSection/HeaderSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbyPopularSpeciesSection"] */ "/app/src/views/Species/components/NearbyPopularSpeciesSection/NearbyPopularSpeciesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NearbyWatersSection"] */ "/app/src/views/Species/components/NearbyWatersSection/NearbyWatersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TipsSection"] */ "/app/src/views/Species/components/TipsSection/TipsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopBaitsSection"] */ "/app/src/views/Species/components/TopBaitsSection/TopBaitsSection.tsx");
